import appCONST from 'constants/app.constants';

export default function AdminHotelEditService(
    $http,
    $q,
    adminHotelListService
) {
    'ngInject';

        Object.assign(this, {
            getHotelProfile,
            isDataModified,
            saveHotelProfile,
        });

        const OPTIONS = {
            nameOptions: 'name',
            addressOptions: 'address',
            cityOptions: 'city',
            countryOptions: 'country',
            postCodeOptions: 'postCode',
            coordinatesOptions: 'coordinates',
            telephoneOptions: 'telephone',
            starsQuantityOptions: 'starsQuantity',
            faxOptions: 'fax',
            emailOptions: 'email',
            generalDescriptionOptions: 'generalDescription',
            propertyLocationOptions: 'propertyLocation',
            roomInformationOptions: 'roomInformation',
            otherInformationOptions: 'otherInformation',
            knowBeforeYouGoOptions: 'knowBeforeYouGo',
            checkInInstructionsOptions: 'checkInInstructions',
            diningInformationOptions: 'diningInformation',
            hotelPolicyOptions: 'hotelPolicy',
        };

        function getHotelProfile(hotelId) {
            const url = `${appCONST.apiUrl}/management/hotels/${hotelId}/details`;
            return $http.get(url)
                .then(({data: {hotel}}) => {
                    attachHasSupplierField(hotel);
                    return reformatAmenities(hotel);
                });

            function reformatAmenities(hotel) {
                const formattedAmenities = [];
                if (!hotel.amenities || hotel.amenities.length === 0) {
                    return hotel;
                }
                const uniqueSuppliers = hotel.amenities
                    .map(({supplier}) => supplier)
                    .filter((id, idx, self) => self.indexOf(id) === idx);
                const selectedSupplier = hotel.amenities.find(({isSelected}) => isSelected);
                const defaultSupplier = selectedSupplier && selectedSupplier.supplier || uniqueSuppliers[0];

                uniqueSuppliers.forEach((id) => {
                    const amenity = {
                        supplier: id,
                        supplierLogo: adminHotelListService.getSupplierLogo(id),
                        isSelected: id === defaultSupplier,
                        amenities: getSuppliersBySupplierId(id),
                    };
                    formattedAmenities.push(amenity);
                });

                function getSuppliersBySupplierId(supplierId) {
                    return hotel.amenities.filter(({supplier}) => supplier === supplierId);
                }

                hotel.amenities = formattedAmenities;
                return hotel;
            }

            function attachHasSupplierField(hotel) {
                Object.keys(OPTIONS).forEach((optionName) =>
                    (hotel[optionName] || []).forEach((item) =>
                        item.hasSupplier = item.supplier !== null));

                return hotel;
            }
        }

        function isDataModified(original, modified) {
            const originalMap = {
                selected: getSelectedSuppliers(original),
                amenities: getSelectedAmenities(original),
                images: getSelectedImages(original),
                boolean: getBooleanOptions(original),
            };
            const modifiedMap = {
                selected: getSelectedSuppliers(modified),
                amenities: getSelectedAmenities(modified),
                images: getSelectedImages(modified),
                boolean: getBooleanOptions(modified),
            };
            return !angular.equals(originalMap, modifiedMap);

            function getSelectedSuppliers(data) {
                return Object.keys(OPTIONS)
                    .map((option) => ({option, value: data[option]}))
                    .filter(({value}) => Array.isArray(value))
                    .reduce((accumulator, {option, value}) => {
                        const selected = value.find(({isSelected}) => isSelected) || {supplier: ''};
                        accumulator[option] = selected.supplier || selected.fieldValue;
                        return accumulator;
                    }, {});
            }

            function getBooleanOptions(data) {
                const {
                    isBillbackEnabled,
                    isBlacklisted,
                    isKtPreferred,
                } = data;

                return {
                    isBillbackEnabled,
                    isBlacklisted,
                    isKtPreferred,
                };
            }
        }

        function saveHotelProfile(data) {
            const hotel = Object.keys(OPTIONS).map((oldKey) => ({
                    newKey: OPTIONS[oldKey],
                    option: (data[oldKey] || []).find(({isSelected}) => isSelected) || null,
                }))
                .reduce((accumulator, {newKey, option}) => {
                    accumulator[newKey] = option
                        ? {value: option.fieldValue, supplier: option.supplier}
                        : null;

                    return accumulator;
                }, {});

            const {
                id,
                isBillbackEnabled,
                isBlacklisted,
                isKtPreferred,
            } = data;

            Object.assign(hotel, {
                id,
                isBillbackEnabled,
                isBlacklisted,
                isKTPreferred: isKtPreferred,
                images: getSelectedImages(data),
            });

            const endpoint = `${appCONST.apiUrl}/management/hotels/${id}/details`;
            return $http.post(endpoint, {hotel});
        }

        function getSelectedAmenities(data) {
            return (data.amenities || [])
                .filter(({isSelected}) => isSelected)
                .reduce((accumulator, value) => accumulator.concat(value.amenities), [])
                .filter(({isSelected}) => isSelected)
                .sort((image1, image2) => image1.priority - image2.priority)
                .map(({id}) => id);
        }

        function getSelectedImages(data) {
            return (data.images || [])
                .filter(({isSelected}) => isSelected)
                .sort((image1, image2) => image1.priority - image2.priority)
                .map(({id, priority}, index) => ({id, priority: index + 1}));
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-service.js